import { useLanguage } from '@/components/utils/useLanguage';
import CarouselWithHeader, { CarouselItem } from '@/components/ui/CarouselWithHeader';
import FeatureSliderCard from '@/components/home/FeatureSliderCard';
import { container, sectionPadding, sectionBgLight } from '@/lib/ds';

export default function UpdatesSection({ features = [] }) {
  const { t } = useLanguage();

  return (
    <section className={`${sectionPadding} ${sectionBgLight}`}>
      <div className={container}>
        <CarouselWithHeader
          title={t('Die neuesten Updates', 'The newest updates')}
          ctaLabel={t('Entdecke, was es Neues gibt', 'Discover what`s new')}
          ctaTo="/updates"
        >
          {features.map(feature => (
            <CarouselItem key={feature.id} className="pl-4 basis-4/5 sm:basis-1/2 lg:basis-1/3 xl:basis-1/4 2xl:basis-1/5">
              <FeatureSliderCard feature={feature} />
            </CarouselItem>
          ))}
        </CarouselWithHeader>
      </div>
    </section>
  );
}